import { render } from "./LinkNavigator.vue?vue&type=template&id=1f897609&scoped=true"
import script from "./LinkNavigator.vue?vue&type=script&lang=js"
export * from "./LinkNavigator.vue?vue&type=script&lang=js"

import "./LinkNavigator.vue?vue&type=style&index=0&id=1f897609&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f897609"]])

export default __exports__